const DISHES_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: undefined,
  isDishTypeMenuTitleUpdateLoading: false,
  dishTypeMenuTitleUpdateError: undefined,
  hotkeys: {
    selectedRowKey: undefined,
    selectedCellKey: undefined,
    isHotkeyEditModeEnabled: false,
    isDrawerNavigationEnabled: false,
  },
  drawerHotkeys: {
    selectedRowKey: undefined,
    selectedCellKey: undefined,
  },
  names: [],
  isNamesLoading: false,
  namesError: undefined,
  availableForQaCounts: [],
  isAvailableForQaCountsLoading: false,
  availableForQaCountsError: undefined,
  curationDates: [],
  isCurationDatesLoading: false,
  curationDatesError: undefined,
  availableForQcCounts: [],
  isAvailableForQcCountsLoading: false,
  availableForQcCountsError: undefined,
  qaDates: [],
  isQaDatesLoading: false,
  qaDatesError: undefined,
  progressCounts: {},
  isProgressCountsLoading: false,
  progressCountsError: undefined,
  drawer: {
    selectedDishId: undefined,
    selectedDrawerType: undefined,
  },
  isUsedMetadataCountsLoading: false,
  usedMetadataCounts: {},
  usedMetadataCountsError: undefined,
}

export default DISHES_INITIAL_STATE
